import { motion } from 'framer-motion';
import React from 'react';
import { useI18n } from '../../i18n/I18nProvider';

const WhyJestAndTestingLibrary: React.FC = () => {
  const { t } = useI18n();

  return (
    <section className="py-12 md:py-16 relative overflow-hidden">
      <motion.div
        className="absolute inset-0 bg-gradient-to-br from-primary/30 via-primary/20 to-secondary/30"
        animate={{
          background: [
            'linear-gradient(to bottom right, rgba(var(--primary), 0.3), rgba(var(--primary), 0.2), rgba(var(--secondary), 0.3))',
            'linear-gradient(to bottom right, rgba(var(--primary), 0.4), rgba(var(--primary), 0.3), rgba(var(--secondary), 0.4))',
            'linear-gradient(to bottom right, rgba(var(--primary), 0.3), rgba(var(--primary), 0.2), rgba(var(--secondary), 0.3))',
          ],
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
          repeatType: "reverse",
        }}
      />
      <div className="container mx-auto px-4 text-center relative z-10">
        <motion.h2 
          className="text-3xl font-semibold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-primary to-primary/70"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          {t.sections.whyJestAndTestingLibrary.title}
        </motion.h2>
        <motion.p 
          className="max-w-3xl mx-auto text-muted-foreground leading-relaxed"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          {t.sections.whyJestAndTestingLibrary.content}
        </motion.p>
      </div>
    </section>
  );
};

export default WhyJestAndTestingLibrary; 